import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/java.svg'
import _imports_1 from '@/assets/images/CertificadoToken.svg'
import _imports_2 from '@/assets/images/Etapa1.gif'
import _imports_3 from '@/assets/images/Etapa2.gif'
import _imports_4 from '@/assets/images/Etapa3.gif'
import _imports_5 from '@/assets/images/doneTokenA3.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { "aria-label": "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-item active" }
const _hoisted_7 = { class: "mt-5 d-flex flex-wrap justify-content-around" }
const _hoisted_8 = { class: "col-md-4 d-flex flex-column" }
const _hoisted_9 = { class: "justify-content-center align-item-center" }
const _hoisted_10 = {
  class: "btn btn-outline-info",
  type: "button",
  href: "https://www.java.com/pt-BR/",
  target: "_blank"
}
const _hoisted_11 = { class: "col-md-4 d-flex flex-column" }
const _hoisted_12 = { class: "justify-content-end" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "my-5" }
const _hoisted_15 = { class: "card p-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-6 text-start" }
const _hoisted_18 = { class: "text-item pe-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "breadcrumb-voucher py-3" }, null, -1)),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ol", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                class: "color--info",
                name: "house"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "color--info",
            to: `/${_ctx.routeHome}`
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", null, "Emissão de certificado", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "color--primary disabled fw-600",
            to: "/"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Cartão e Token")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "h-large text-start" }, "Emissão Online", -1)),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "my-5 text-start" }, [
      _createElementVNode("span", null, [
        _createElementVNode("strong", null, "Emitir"),
        _createTextVNode(" ou "),
        _createElementVNode("strong", null, "Renovar"),
        _createTextVNode(" seu Certificado agora ficou mais "),
        _createElementVNode("strong", null, "fácil"),
        _createTextVNode("!")
      ]),
      _createElementVNode("div", { class: "my-2" }, "Se você já tem um Certificado em token ou cartão, basta seguir o passo a passo abaixo.")
    ], -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex" }, [
          _createElementVNode("img", { src: _imports_0 }),
          _createElementVNode("div", { class: "flex-column text-start p-2" }, [
            _createElementVNode("div", { class: "h-medium" }, "Passo 1"),
            _createElementVNode("span", null, "Atualizar ou fazer o download do Java em seu computador")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "download"
            }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Download do Java", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex" }, [
          _createElementVNode("img", { src: _imports_1 }),
          _createElementVNode("div", { class: "flex-column text-start p-2" }, [
            _createElementVNode("div", { class: "h-medium" }, "Passo 2"),
            _createElementVNode("span", null, "Fazer download da aplicação e executar em seu computador")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            class: "btn btn-primary",
            href: `https://${_ctx.form.arData.subdomain}.acsoluti.com.br/renovacao/jnlp`,
            type: "button"
          }, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "download"
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Download da aplicação", -1))
          ], 8, _hoisted_13)
        ])
      ])
    ]),
    _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"my-5\" data-v-1fcc4d2c><div class=\"card p-4\" data-v-1fcc4d2c><div class=\"row\" data-v-1fcc4d2c><div class=\"col-6 d-flex justify-content-center\" data-v-1fcc4d2c><img src=\"" + _imports_2 + "\" width=\"350px\" height=\"270px\" data-v-1fcc4d2c></div><div class=\"col-6 text-start\" data-v-1fcc4d2c><div class=\"subtitle-large my-2\" data-v-1fcc4d2c>Passo 3</div><div class=\"text-item pe-1\" data-v-1fcc4d2c><div data-v-1fcc4d2c>Após executar nossa aplicação <strong data-v-1fcc4d2c>selecione qual o Token ou Cartão deseja utilizar</strong>.</div><div data-v-1fcc4d2c>OBS. É necessário ser um Certificado Digital válido.</div><div class=\"mt-4\" data-v-1fcc4d2c><strong data-v-1fcc4d2c>Digite a senha do dispositivo Token ou Cartão</strong>.</div><div data-v-1fcc4d2c>OBS: A senha requerida ainda NÃO é a senha de emissão e sim a senha do seu dispositivo.</div><div class=\"mt-4\" data-v-1fcc4d2c><strong data-v-1fcc4d2c>Selecione o Certificado</strong> que deseja utilizar para se autenticar.</div></div></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-6 d-flex justify-content-center" }, [
            _createElementVNode("img", {
              src: _imports_3,
              style: {"width":"350px","height":"270px"},
              alt: "Etapa"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "subtitle-large my-2" }, "Passo 4", -1)),
            _createElementVNode("div", _hoisted_18, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mt-2" }, [
                _createElementVNode("strong", null, "Insira o número do Voucher ou Pedido"),
                _createTextVNode(" e em seguida "),
                _createElementVNode("strong", null, "preencha os campos obrigatórios.")
              ], -1)),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-4" }, "Ainda não tem um voucher ou um número de pedido?", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("div", null, "Entre em contato conosco e adquira!", -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(_ctx.form.arData.foneAR), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.siteArFormatted), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"my-5\" data-v-1fcc4d2c><div class=\"card p-4\" data-v-1fcc4d2c><div class=\"row\" data-v-1fcc4d2c><div class=\"col-6 d-flex justify-content-center\" data-v-1fcc4d2c><img src=\"" + _imports_4 + "\" width=\"350px\" height=\"270px\" data-v-1fcc4d2c></div><div class=\"col-6 text-start\" data-v-1fcc4d2c><div class=\"subtitle-large my-2\" data-v-1fcc4d2c>Passo 5</div><div class=\"text-item pe-1\" data-v-1fcc4d2c><div class=\"mt-2\" data-v-1fcc4d2c><strong data-v-1fcc4d2c>Agora crie a senha de emissão.</strong></div><div data-v-1fcc4d2c>IMPORTANTE: <strong data-v-1fcc4d2c>Guarde esta senha</strong>, pois não será possível recuperar.</div></div></div></div></div></div><div class=\"my-5\" data-v-1fcc4d2c><div class=\"card p-4\" data-v-1fcc4d2c><div class=\"row\" data-v-1fcc4d2c><div class=\"col-6 d-flex justify-content-center\" data-v-1fcc4d2c><img src=\"" + _imports_5 + "\" width=\"340px\" height=\"195px\" data-v-1fcc4d2c></div><div class=\"col-6 text-start\" data-v-1fcc4d2c><div class=\"subtitle-large my-2\" data-v-1fcc4d2c>Prontinho!</div><div class=\"text-item pe-1\" data-v-1fcc4d2c><div data-v-1fcc4d2c>Após aguardar alguns segundos, você receberá a mensagem que seu Certificado Digital foi aprovado e receberá um e-mail com as instruções para a instalação!</div></div></div></div></div></div>", 2)),
    _createVNode(_component_Contact, { style: {"margin-bottom":"6rem"} })
  ]))
}